<template>
  <div class="confirmLicense">
    <h1>Confirm License</h1>
    <el-card class="box-card">
      <h2>Modify License Form</h2>
      <el-form ref="newLicenseForm" label-position="left" :model="newLicenseForm" label-width="150px">

        <el-form-item label="Expiry Date [as UTC(+00:00)]">
          <el-col :span="11">
            <el-date-picker type="date" placeholder="Select Date" :default-value="new Date()" v-model="tmp_exp_date"
                            value-format="yyyy-MM-ddTHH:mm:ss.000Z"
                            @change="OnExpiryDateChange"
                            style="width: 100%;"></el-date-picker>
          </el-col>
        </el-form-item>

        <el-form-item>
          <el-button type="success" plain @click="modifyLicense" :loading="modifying">Submit</el-button>
        </el-form-item>
      </el-form>
    </el-card>

  </div>
</template>

<script>
import {modifyLicense} from '../api'
export default {
  name: 'ConfirmLicense',
  data () {
    console.log(this.$route.params.data)
    return {
      modifying: false,
      deprecate_exp_date: null,
      newLicenseForm: null,
      tmp_exp_date: null
    }
  },
  methods: {
    modifyLicense () {
      const that = this
      that.modifying = true
      that.newLicenseForm = that.$route.params.data
      Object.assign(that.newLicenseForm, {'deprecate_exp_date': this.deprecate_exp_date})

      console.log('newLicenseForm')
      console.log(that.newLicenseForm)

      modifyLicense(that.newLicenseForm).then(data => {
        that.modifying = false

        console.log('modifyLicense Success')
        console.log('modifyLicense Success -> data.data')
        console.log(data.data)
        console.log('modifyLicense Success -> data')
        console.log(data)

        that.$router.push({name: 'CompleteLicense', params: {data: data.data}})
      }).catch(error => {
        if (error) {
          console.log(error.stack)
        }
        that.modifying = false
      })
    },
    OnExpiryDateChange (value) {
      var datum = Date.parse(value)
      this.newLicenseForm.exp_date = datum
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.welcome{
  margin: 0px auto;
  max-width: 350px;
  position: relative;
  margin-top: 50px;
}
</style>

<style>
.el-table .cell {
  word-break: break-word;
}
</style>



// WEBPACK FOOTER //
// ConfirmLicense.vue?fa8d93e6